// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__GpgLP","commentsWrapper":"styles_commentsWrapper__0VXIN"};